// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"persons_wrapper__zRAQQ"};